import Vue from 'vue'
import define from '../systemAdminDefineModules/systemAdminDefineMutation.js'
// maintenance-action
const URL = process.env.API_MASTER_URL
const header = define.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  inputAddUpdate(store, payload) {
    store.commit('inputAddUpdate', payload)
  },
  updateSelectedTenantList(store, payload) {
    store.commit('updateSelectedTenantList', payload)
  },
  clearUpdateData(store) {
    store.commit('clearUpdateData')
  },
  clearAddData(store) {
    store.commit('clearAddData')
  },
  clearSelectedTenantList(store) {
    store.commit('clearSelectedTenantList')
  },
  async setMaintenance(store, payload) {
    let logContinue = true
    let pageNo = 0
    const count = 200
    const margeData = {
      data: {
        header: {},
        data: {maintenanceList: [], status: ''}
      }
    }
    while (logContinue) {
      const config = {
        headers: {
          Authorization: define.state.authorization
        },
        timeout: 1000 * 30
      }
      let params = {
        pageNo: pageNo,
        count: count
      }
      if (header.companyId) {
        params.tenantId = header.companyId
      }
      const data = {
        header,
        data: params
      }
      var response = await Vue.http.post(
        URL + '/v2/master/maintenance/list',
        data,
        config
      )

      const size = response.data['data']['maintenanceList'].length
      for (let i = 0; i < size; i++) {
        margeData.data.data.maintenanceList.push(
          response.data['data']['maintenanceList'][i]
        )
      }
      pageNo++
      if (size < count) {
        margeData.data.header = response.data['header']
        margeData.data.data.status = response.data['data']['status']
        logContinue = false
      }
    }

    // 成功後の処理
    store.commit('setMaintenance', margeData)
  },

  async setMaintenanceDetail(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        maintenanceId: payload.maintenanceId
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/master/maintenance/detail',
      data,
      config
    )

    // 成功後の処理
    store.commit('setMaintenanceDetail', response)
  },

  async addMaintenance(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        message: payload.message,
        startDateTime: payload.startDateTime,
        endDateTime: payload.endDateTime,
        allFlag: payload.allFlag,
        companyIdList: payload.companyIdList
      }
    }
    await Vue.http.post(URL + '/v2/master/maintenance/regist', data, config)
  },

  async updateMaintenance(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        maintenanceId: payload.maintenanceId,
        message: payload.message,
        startDateTime: payload.startDateTime,
        endDateTime: payload.endDateTime,
        allFlag: payload.allFlag,
        companyIdList: payload.companyIdList
      }
    }
    await Vue.http.post(URL + '/v2/master/maintenance/update', data, config)
  },

  async deleteMaintenance(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        maintenanceId: payload.maintenanceId
      }
    }
    await Vue.http.post(URL + '/v2/master/maintenance/delete', data, config)
  }
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/maintenanceModules/actions.js